module.exports = __webpack_public_path__ + "img/icon-play.e8d8528a.svg";